function initUspRotators() {
  const rotators = document.querySelectorAll('[data-usp-rotator]');

  rotators.forEach((view) => {
    // Prevent duplicate initialization (important for Shopify)
    if (view.dataset.initialized === "true") return;
    view.dataset.initialized = "true";

    const line = view.querySelector('.gsp-usp-line');
    if (!line) return;

    const items = line.children;
    if (items.length <= 1) return; // No rotation if only 1 USP

    let idx = 0;
    const intervalMs = 2500;
    let rowH = items[0].offsetHeight || 18;

    function setHeight() {
      rowH = items[0].offsetHeight || rowH;
      view.style.height = rowH + 'px';
      line.style.transform = `translateY(-${idx * rowH}px)`;
    }

    setHeight();

    // Recalculate after images/fonts load
    window.addEventListener('load', setHeight);

    let resizeTO;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTO);
      resizeTO = setTimeout(setHeight, 200);
    });

    setInterval(() => {
      idx = (idx + 1) % items.length;
      line.style.transform = `translateY(-${idx * rowH}px)`;
    }, intervalMs);
  });
}

// Initial load
document.addEventListener('DOMContentLoaded', initUspRotators);

// VERY IMPORTANT for Shopify (section reload in customizer, filters, etc.)
document.addEventListener('shopify:section:load', initUspRotators);
document.addEventListener('shopify:section:reorder', initUspRotators);